import { Chip, MenuItem, Select } from "@mui/material";
import useAuth from "../../hooks/useAuth";
import { USE_FAKE_DATA } from "../../config/appConfig";
import { useState } from "react";

const Dashboard = () => {
  const user = useAuth();
  const roleVal = (user as unknown as { role?: number | string })?.role;
  const defaultRole: string = USE_FAKE_DATA ? "SUPER_ADMIN" : (typeof roleVal === 'string' ? roleVal : "SUPER_ADMIN");

  const [fakeRole, setFakeRole] = useState<string>(defaultRole);
  const effectiveRole = USE_FAKE_DATA ? fakeRole : defaultRole;

  const kpiCard = (icon: string, value: string | number, label: string, href?: string) => (
    href ? (
      <a href={href} className="cards">
        <figure><img src={icon} alt="Icon" /></figure>
        <h2>{value}</h2>
        <p>{label}</p>
      </a>
    ) : (
      <div className="cards">
        <figure><img src={icon} alt="Icon" /></figure>
        <h2>{value}</h2>
        <p>{label}</p>
      </div>
    )
  );

  const Section = ({ title, right }: { title: string; right?: React.ReactNode }) => (
    <div className="cards table_card">
      <div className="cards_header">
        <div className="left_s"><h2>{title}</h2></div>
        <div className="right_s">{right}</div>
      </div>
      <div style={{ padding: 16 }}>
        <div style={{ color: '#64748b' }}>No data source connected. Displaying placeholders.</div>
      </div>
    </div>
  );

  return (
    <>
      <div className="main_title">
        <h1>Dashboard</h1>
        {USE_FAKE_DATA && (
          <div style={{ marginLeft: 'auto' }}>
            <Select size="small" value={fakeRole} onChange={(e) => setFakeRole(e.target.value)}>
              <MenuItem value="SUPER_ADMIN">Super Admin</MenuItem>
              <MenuItem value="SALES_MANAGER">Sales Manager</MenuItem>
              <MenuItem value="OPERATIONS_MANAGER">Operations Manager</MenuItem>
              <MenuItem value="FINANCE_MANAGER">Finance Manager</MenuItem>
              <MenuItem value="SUPPORT">Support</MenuItem>
            </Select>
          </div>
        )}
      </div>

      {effectiveRole === "SUPER_ADMIN" && (
        <>
          <div className="stats_boxes gap_m">
            {kpiCard("/static/images/user_icon.svg", 742, "Total customers onboarded", "/manage-users")}
            {kpiCard("/static/images/report_icon.svg", 12, "Pending RFQs", "/rfq")}
            {kpiCard("/static/images/booking.svg", 18, "Today’s confirmed bookings", "/bookings")}
            {kpiCard("/static/images/delivery.svg", 7, "Active deliveries", "/delivery")}
            {kpiCard("/static/images/finance.svg", 5, "Overdue invoices", "/finance")}
          </div>

          <div className="grid_sc gap_m">
            <div className="cards table_card">
              <div className="cards_header">
                <div className="left_s"><h2>API Status Monitor</h2></div>
              </div>
              <div style={{ padding: 16, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                <Chip color="success" label="ERP: Up" size="small" />
                <Chip color="success" label="Payment Gateway: Up" size="small" />
                <Chip color="success" label="AFAQY: Up" size="small" />
              </div>
            </div>
          </div>
        </>
      )}

      {effectiveRole === "SALES_MANAGER" && (
        <>
          <div className="stats_boxes gap_m">
            {kpiCard("/static/images/user_icon.svg", 6, "Pending access requests", "/manage-users")}
            {kpiCard("/static/images/report_icon.svg", 12, "Pending RFQs", "/rfq")}
            {kpiCard("/static/images/booking.svg", "34%", "RFQ → Booking conversion")}
          </div>
        </>
      )}

      {effectiveRole === "OPERATIONS_MANAGER" && (
        <>
          <div className="stats_boxes gap_m">
            {kpiCard("/static/images/delivery.svg", 22, "Today’s scheduled deliveries", "/delivery")}
            {kpiCard("/static/images/delivery.svg", 9, "Ongoing trips", "/delivery")}
            {kpiCard("/static/images/report_icon.svg", 3, "Exception alerts")}
          </div>

          <div className="cards" style={{ marginTop: 16 }}>
            <div className="cards_header">
              <div className="left_s"><h2>Ongoing Trips</h2></div>
            </div>
            <div style={{ height: 280, borderRadius: 8, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
              <iframe title="Ops Map" width="100%" height="100%" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d57818.468889342306!2d55.2708!3d25.2048!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sAE!4v1700000000000" />
            </div>
          </div>
        </>
      )}

      {effectiveRole === "FINANCE_MANAGER" && (
        <>
          <div className="stats_boxes gap_m">
            {kpiCard("/static/images/finance.svg", 5, "Overdue invoices", "/finance")}
            {kpiCard("/static/images/finance.svg", 8, "Pending payments", "/finance")}
            {kpiCard("/static/images/finance.svg", "AED 42k", "Daily collections", "/finance")}
          </div>
        </>
      )}

      {effectiveRole === "SUPPORT" && (
        <>
          <div className="stats_boxes gap_m">
            {kpiCard("/static/images/notification2_icon.svg", 11, "Open tickets")}
            {kpiCard("/static/images/notification2_icon.svg", 2, "SLA breach alerts")}
            {kpiCard("/static/images/cms_icon.svg", 47, "Top FAQ searches")}
          </div>
        </>
      )}
    </>
  );
};

export default Dashboard;